<template>
  <div>
    <b-navbar toggleable="lg" type="dark" variant="dark" class="navbar-my">
      <b-navbar-brand href="#">
        <img height="40" src="/logo-dark.png" alt="Brand Logo">
      </b-navbar-brand>

      <button
        type="button"
        aria-label="Toggle navigation"
        class="navbar-toggler collapsed"
        :aria-expanded="isMenuCollapsed"
        aria-controls="nav-collapse"
        @click="toggleMenu"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <b-collapse id="nav-collapse" is-nav v-model="isMenuCollapsed">
        <b-navbar-nav class="align-items-center ml-auto">
          <b-nav-item to="/">
            <span class="nav-link-inner--text text-white">Dashboard</span>
          </b-nav-item>
          <b-nav-item to="/devices">
            <span class="nav-link-inner--text text-white">Devices</span>
          </b-nav-item>
          <b-nav-item to="/companies">
            <span class="nav-link-inner--text text-white">Companies</span>
          </b-nav-item>
          <b-nav-item to="/batches">
            <span class="nav-link-inner--text text-white">Batches</span>
          </b-nav-item>
          <b-nav-item to="/scan">
            <span class="nav-link-inner--text text-white">Scan</span>
          </b-nav-item>
          
          <b-nav-item to="/settings">
            <span class="nav-link-inner--text text-white">Settings</span>
          </b-nav-item>

          <!-- Account Dropdown -->
          <base-dropdown menu-on-right class="nav-item" tag="li" title-tag="a" title-classes="nav-link pr-0">
            <a href="#" class="nav-link pr-0" @click.prevent="handleAccountClick" slot="title-container">
              <b-media no-body class="align-items-center">
                <span class="avatar avatar-sm rounded-circle bg-primary">{{ usernameShort }}</span>
                <b-media-body class="ml-2 d-none d-lg-block">
                  <span class="mb-0 text-sm font-weight-bold text-white">{{ username }}</span>
                </b-media-body>
              </b-media>
            </a>
            <template>
              <b-dropdown-item to="/settings">
                <i class="ni ni-settings-gear-65"></i>
                <span>Settings</span>
              </b-dropdown-item>
              <b-dropdown-item @click="toggleDarkMode" class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <i class="ni ni-palette mr-2"></i>
                  <span>Dark Mode</span>
                </div>
              </b-dropdown-item>
              <b-dropdown-divider/>
              <b-dropdown-item href="#!" @click="onLogout">
                <i class="ni ni-user-run"></i>
                <span>Logout</span>
              </b-dropdown-item>
            </template>
          </base-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
export default {
  name: 'MainNav',
  data() {
    return {
      isMenuCollapsed: false,
      keepMenuOpen: false
    }
  },
  computed: {
    ...mapGetters(['username', 'usernameShort', 'activeEntity']),
    ...mapState({
      rights: state => state.auth.rights
    })
  },
  methods: {
    handleAccountClick() {
      this.keepMenuOpen = true
    },
    toggleMenu() {
      this.isMenuCollapsed = !this.isMenuCollapsed
    },
    onLogout() {
      this.$store.dispatch('auth/logout').then(() => {
        this.$router.push({ name: 'login' })
      })
    },
    toggleDarkMode() {
      this.$store.commit('darkMode/toggleDarkMode')
    }
  },
  watch: {
    isMenuCollapsed(newVal) {
      if (!newVal && this.keepMenuOpen) {
        this.$nextTick(() => {
          this.isMenuCollapsed = true
          this.keepMenuOpen = false
        })
      }
    }
  }
}
</script>

<style lang="scss">
.active { font-weight: bold !important; }
.navbar-my {
  position: fixed !important;
  top: 0; width: 100%; z-index: 100;
  border-bottom: 1px solid #00000055 !important;
  background-color: #172b4d !important;
}
</style>